import React, { useState, useEffect } from "react";
import image from "../../../assets/BannerImg.png";

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const bannerImages = [image, image, image];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevIndex) => {
        if (prevIndex === bannerImages.length - 1) {
          const container = document.querySelector(
            ".flex.transition-transform"
          );
          if (container) {
            container.style.transition = "none";
            setCurrentSlide(0);
            void container.offsetHeight;
            container.style.transition = "transform 500ms ease-in-out";
          }
          return 0;
        }
        return prevIndex + 1;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [bannerImages.length]);

  return (
    <div className="w-full overflow-hidden">
      <div
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {bannerImages.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Banner ${index + 1}`}
            className="w-full h-[550px] object-fit flex-shrink-0 object-center"
          />
        ))}
      </div>

      <div className="flex justify-center mt-4 gap-2">
        {bannerImages.map((_, index) => (
          <button
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ease-in-out ${
              currentSlide === index ? "bg-[#8860D0]" : "bg-gray-500/50"
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Banner;
